import { AxiosResponse } from "axios";
import { IAbstractModel } from "model/abstract.model";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../axios/axios.config";
import { TdadosGeneric } from "./pagamento.model";


const PagamentoService = () => {
    const path = '/flow';
    const loginService = LoginService();

    return {
        getFormasPagamento(): Promise<AxiosResponse<Array<IAbstractModel>>> {
            return axiosRequest.get(`${path}/formaspagamento`, { headers: loginService.getHeaders() });
        },
        getBancos(): Promise<AxiosResponse<Array<IAbstractModel>>> {
            return axiosRequest.get(`${path}/bancos`, { headers: loginService.getHeaders() });
        },
        getParcelasCondicaoPagamentoSelecionada(formaPagamentoUuid: string, condicaoPagamentoUuid: string, valor: number): Promise<AxiosResponse<Array<TdadosGeneric>>> {
            return axiosRequest.get(
                `/condicaopagamento/calcular-parcelas`,
                {
                    headers: loginService.getHeaders(),
                    params: {
                        formaPagamentoUuid, condicaoPagamentoUuid, valor
                    }
                });
        },
    };
};

export default PagamentoService;
